import axiosInstance from '../axiosInstance';

/**
 * App usage — how long a carer had the mobile app open while signed in.
 * Opened from Staff Management's 3-dot menu ("View app usage").
 *
 * The phones time it and report each session once, when the carer leaves the
 * app; nothing here is estimated on the client. Managers and owners only — the
 * API enforces that. See api/utils/appUsage.js.
 */
const appUsageService = {
  /**
   * One person's day-by-day time and sessions at the active site, for a range
   * of UK dates (inclusive; at most 92 days). Without dates: the last 7 days.
   *
   * Returns `{ range, person, daily, sessions, sessions_truncated }`.
   * `person.tracked` false means their app has never reported usage — not the
   * same as zero (an older app version, or not signed in since updating).
   */
  getPerson: async (userId, { from, to } = {}) => {
    const res = await axiosInstance.get(`/carehome-manager/app-usage/people/${userId}`, {
      params: { from: from || undefined, to: to || undefined },
    });
    return res.data;
  },
};

export default appUsageService;
